<template>
    <div class="fixed-container d-inline-flex btn-lang-en">
        <router-link  :to="{name: 'es'}">
            <button type="submit" class="btn btn-sm btn-outline-light mx-0 rounded-0 border-0">
                <img src="../assets/peru.svg" width="25" alt="">
            </button>
        </router-link>
    </div>

    <categorynewComponent
    :categories="getters_en"
    :allergens="getters_allergens_en" 
    id_beer="2"
    id_wine="35"
    btn_name="SEE MORE"
    ></categorynewComponent>
        


</template>
<script>

import { onMounted,computed,onUpdated } from "vue";
import {useStore} from "vuex";
//import categoryComponent from '../components/web/categoryComponent.vue'
import categorynewComponent from '@/components/web/categorynewComponent.vue'


import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default {
    name: 'enView',
    components:{
        categorynewComponent
    },
    setup(){
        const store = useStore();
        const getters_en = computed(() => store.getters.getters_en)
        //const v_categories = 
        onMounted(() => {
            //console.log(getters_en.value.length)
            if (!store.state.v_success){
                store.dispatch('v_action_categories').then(() => {
                
                });//store
            }//if
            

        //     gsap.to(".btn-lang-en",{
        //   scrollTrigger: {
        //   trigger: ".btn-lang-en",
        //  start: "start+=150 center-=270",
        //         end: "bottom+=200 bottom",
        //   //markers: true,
        //   scrub:1,
          
        //   },
        //   opacity:0
        //   })
        })


        onUpdated(()=>{
          //console.log('lang actualizado')
          
        })


        return{
            store,
            getters_en,
            getters_allergens_en: computed(() => store.getters.getters_allergens_en),
            
        }
    }
}


</script>

<style>

</style>